import { FETCH_REVIEWS, FETCH_REVIEWS_SUCCESS, FETCH_REVIEWS_FAIL } from 'actions/chargingStation';

const initialState = {
  isLoading: false,
  reviews: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const reviewReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_REVIEWS: {
      return { ...state, isLoading: true };
    }

    case FETCH_REVIEWS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        reviews: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case FETCH_REVIEWS_FAIL: {
      return { ...state, isLoading: false };
    }

    default:
      return { ...state };
  }
};
export default reviewReducer;
